import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CancelIcon from '@material-ui/icons/Cancel';
import successIcon from '../assets/images/success-icon.png';
interface DialogBoxProps {
    handleDialogClose: any;
    open: any;
    message: any;
    imgDisp?: boolean;
}

export const DialogBox: React.FC<DialogBoxProps> = (props: DialogBoxProps) => {
    const {
        handleDialogClose, open, message, imgDisp
    } = props;
    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" className={imgDisp !== false ? '' : 'imgDisp'}>
                {imgDisp !== false &&
                <div className='promo-success-img'>
                    <img src={successIcon} alt='Cross Icon' className='checkIcon' />
                </div>}
                <div style={{ textAlign: 'end' }}>
                    <span title="Close" aria-label="Close">
                        <CancelIcon onClick={handleDialogClose} style={{ textAlign: "right", color: "#F29900" }} />
                    </span>
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" className={imgDisp !== false ? 'dialog_description' : 'dialog_description_imgdisp'}>
                    <div dangerouslySetInnerHTML={{ __html: message }}></div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}


export default DialogBox